import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CsrfService {
  private csrfToken: string | null = null;

  get_token(): string | null {
    console.log(`Get ${this.csrfToken}`);
    return this.csrfToken;
  }

  set_token(token: string) {
    this.csrfToken = token;
    console.log(`Set ${token}`);
  }
}
